import { SyncDirection } from "../../../../../../../common/sesh_types";
import SyncTypeBox from "./sync_type_box";

export default function SyncDirectionSelection(props: {
	onSelected: (selectedSyncType: SyncDirection) => void;
}) {
	return (
		<div className="flex flex-col gap-2">
			<h1 className="has-text-weight-bold is-size-5">
				Choose sync direction
			</h1>
			<div className="flex flex-col gap-2">
				<SyncTypeBox
					syncType={SyncDirection.Outbound}
					onSelect={() => {
						props.onSelected(SyncDirection.Outbound);
					}}
				/>
				<SyncTypeBox
					syncType={SyncDirection.Inbound}
					onSelect={() => {
						props.onSelected(SyncDirection.Inbound);
					}}
				/>
				<SyncTypeBox
					syncType={SyncDirection.Bidirectional}
					onSelect={() => {
						props.onSelected(SyncDirection.Bidirectional);
					}}
				/>
			</div>
		</div>
	);
}
